import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { JsonConverter } from '@app-core/services/utility/json-conveter';
import { EndInfo } from '@app-units/models/end-info/end-info';
import { Observable } from 'rxjs';
import { EndInfoOriginInterface } from '@app-units/models/end-info/end-info-origin';

@Injectable()
export class EndInfoHttpService {
  constructor(private http: HttpClient) {}

  fetchItem(id: string): Observable<app.response<EndInfo>> {
    return this.http.get(this.getUrl(id)).pipe(map(JsonConverter.toEndInfo));
  }

  fetchPortalItem(id: string): Observable<app.response<EndInfo>> {
    return this.http
      .get(`/portal/orders/${id}/end_info`)
      .pipe(map(JsonConverter.toEndInfo));
  }

  saveItem(item: EndInfoOriginInterface): Observable<app.response<EndInfo>> {
    return this.http
      .put(this.getUrl(String(item.id)), item)
      .pipe(map(JsonConverter.toEndInfo));
  }

  private getUrl(id: string) {
    return `/orders/${id}/end_info`;
  }
}
